module.exports = __webpack_public_path__ + "static/media/logo_0.1ebdf6ba.png";